import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
    return (
        <section id="contact" className="contact">
            <div className="container">
                <h2>Get In Touch</h2>
                <div className="contact-content">
                    <p>
                        Ready to start your next project? Let's discuss how we can help
                        bring your ideas to life with cutting-edge technology and expert development.
                    </p>

                    <div className="contact-info">
                        <div className="contact-item">
                            <span className="contact-icon">📧</span>
                            <div className="contact-text">
                                <label>Email Us</label>
                                <span><a href="mailto:support@k9hkrstudios.com">support@k9hkrstudios.com</a></span>
                            </div>
                        </div>

                        <div className="contact-item">
                            <span className="contact-icon">💼</span>
                            <div className="contact-text">
                                <label>Services</label>
                                <span>Professional Development Services</span>
                            </div>
                        </div>

                        <div className="contact-item">
                            <span className="contact-icon">🌐</span>
                            <div className="contact-text">
                                <label>Location</label>
                                <span>Remote & On-Site Collaboration</span>
                            </div>
                        </div>
                    </div>

                    <div className="contact-cta">

                    </div>
                </div>
            </div>
        </section >
    );
};

export default Contact;
